// import { StateListType } from './../../../types/state-list-type';
import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  SET_SWITCHES_FILTERS,
  GET_ALL_SUCCESS,
  GET_FILTER_SUCCESS,
  GET_LIST_PRODUCT_SUCCESS,
  SEARCH,
  SET_LOADING_COUNT,
  CLEAR_LIST_PRODUCT
} from './product-constants';
import { ProductStateInterface } from './product-interface';
import { ASYNC_CONFIG } from '~/constants';

const INITIAL_STATE: ProductStateInterface = {
  loadingData: false,
  loadingSend: false,
  loadingCount: false,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    decimals: 2,
    rowsCount: 0,
    page: 1,
    rowsPerPage: 8,
    rowsPerPageOptions: [10, 20, 50, 100],
    rowsOrientation: 'column',
    rowsOrientationOptions: ['column', 'list', 'listWithOutImage'],
    selected: [],
    selectedCount: 0,
    onlyExternalCode: false,
    onlyWithStock: localStorage.getItem(ASYNC_CONFIG.HAVE_STOCK) === 'true',
    onlyWithPromotion: false,
    clientMix: false,
    order: 'asc',
    orderBy: ['name', true]
  }
};

const productReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case GET_FILTER_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.products,
          allRows: action.products,
          rowsCount: action.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...INITIAL_STATE.list,
          rows: action.products,
          allRows: action.products
        }
      };
    }

    case GET_LIST_PRODUCT_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload?.products,
          allRows: action.payload?.products,
          rowsCount: action.payload?.rowsCount ?? state?.list?.rowsCount,
          decimals: action.payload?.decimals
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ROWS_ORIENTATION: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsOrientation: action.rowsOrientation
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SET_SWITCHES_FILTERS: {
      const { name, value } = action.payload;

      return {
        ...state,
        list: {
          ...state.list,
          [name]: value
        }
      };
    }

    case SEARCH: {
      const { queryString } = action;

      const results =
        queryString !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.name?.toLowerCase().startsWith(queryString.toLowerCase()) ||
                item?.barCode?.toLowerCase().startsWith(queryString.toLowerCase()) ||
                item?.brand?.toLowerCase().startsWith(queryString.toLowerCase()) ||
                item?.stock?.availableQuantity?.toString().startsWith(queryString)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    case SET_LOADING_COUNT: {
      return {
        ...state,
        loadingCount: action.loading
      };
    }

    case CLEAR_LIST_PRODUCT: {
      return {
        ...INITIAL_STATE,
        list: {
          ...INITIAL_STATE.list,
          onlyWithStock: state.list.onlyWithStock
        }
      };
    }

    default:
      return state;
  }
};

export default productReducer;
